export default "__VITE_ASSET__CTF7hO44__"